import Reporting from './container';

export default Reporting;
